import { render } from "./header-vue.vue?vue&type=template&id=112d9a83"
import script from "./header-vue.vue?vue&type=script&lang=js"
export * from "./header-vue.vue?vue&type=script&lang=js"

import "./header-vue.vue?vue&type=style&index=0&id=112d9a83&lang=scss"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__